import { InputComponent } from "components/components/Component";
import { SimpleInputBaseDefinition, SimpleInputBaseComponent } from "components/input/baseInputDefinition";
import { LabelElement } from "components/components/label/labelElement";
import { ComponentActionHelper } from "components/events/componentActionHelper";
import template from "./password.hbs";
import { PasswordInputElement, initPasswordInputWebComponent } from "./passwordElement";

initPasswordInputWebComponent();

export class PasswordInput extends SimpleInputBaseComponent<PasswordInputDefinition> implements InputComponent {

    public readonly componentType: string = "passwordInput";

    private element: PasswordInputElement;

    constructor(schema: PasswordInputDefinition) {
        super(schema);
    }

    public render(): Element {
        this.renderTemplate();
        this.bindEvents();
        ComponentActionHelper.register(this);
        return this.view;
    }

    public renderTemplate(): Element {
        let objStyle: any = this.generateSytleAttribute();
        return super.renderTemplate(template, objStyle);
    }

    private generateSytleAttribute(): any {
        let objStyle: any = {};
        let strStyle: string = "";
        if ((this.definition.labelKey == null && this.definition.maxlength > 0)) {
            strStyle += "max-width: calc(" + (1.71 * this.definition.maxlength) + "ch + 14px);";
        }

        if (strStyle !== "") {
            objStyle.style = strStyle;
        }

        return objStyle;
    }

    private bindEvents(): void {

        this.element = this.view.querySelector("s6-password-input");

        const enableKeyUpFinishedTyping = (this.definition.disableFinishedTyping !== true);

        this.genericBindEvents(this.element, enableKeyUpFinishedTyping);
    }

    public getValue(): string {
        return this.element.data;
    }

    public value(v: string) {
        this.element.data = v;
    }

    public setReadOnly(ro: boolean) {
        this.view.querySelector("input").readOnly = ro;
    }

    public setRequired(required: boolean) {
        let inputLabel = this.view.querySelector("s6-input-label");
        if (inputLabel != null) {
            (inputLabel as LabelElement).required = required;
        }
    }

    public setValidationStatus(valid: boolean, message?: string) {
        this.element.valid = valid;
        this.element.validationMessage = message || null;
    }
}

export interface PasswordInputDefinition extends SimpleInputBaseDefinition {
    maxlength?: number;
    disableFinishedTyping?: boolean;
}
